export * from './src/data-v2-index-indexes.universal.js';
